import {AfterContentInit, AfterViewInit, Component} from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PricingConstant, PricingPlanType } from 'src/app/constants/pricing.constants';
import { ReportProvider } from 'src/app/providers';
import { CreditPurchasePopupComponent } from '../../..';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-payment-popup',
  templateUrl: './payment-popup.component.html',
  styleUrls: ['./payment-popup.component.scss']
})
export class PaymentPopupComponent implements AfterViewInit {

  reportId: string = '';
  isFromUnlock: boolean = false;
  basePrice: number = PricingConstant.PRICE_PER_REPORT;
  renewPrice: number = PricingConstant.RENEW_PRICE;
  promo: string;
  payableAmount: number;
  totalDiscount: number;
  sampleBtnDisable: boolean = false;

  constructor(public bsModalRef: BsModalRef,
    private router: Router,
    private modalService: BsModalService,
    private reportProvider: ReportProvider) { }

  ngAfterViewInit() {
    if(this.promo){
      this.applyPromoCode();
    }
  }

  cancel() {
    this.bsModalRef.hide();
  }

  /**
   * @description for open credit purchase popup
   */
   openCreditPurchasePopup() {
    this.bsModalRef.hide();
    this.modalService.show(CreditPurchasePopupComponent, Object.assign({
      initialState: {
        reportId: this.reportId,
        basePrice: this.basePrice
      }
    }, { class: 'modal-lg modal-dialog-centered' }));
  }

  /** Go to billing page */
  gotoBillingPage() {
    this.bsModalRef.hide();
    this.router.navigateByUrl(`report/payment/checkout/${PricingPlanType.REPORT_PURCHASE}/${this.reportId}${(this.promo ? '?promo=' + this.promo : '')}`);
  }

  downloadSample() {
    this.sampleBtnDisable = true;
    this.reportProvider.downloadSampleReport().subscribe(res => {
      if (res) {
        this.saveToSampleReportFile(res);
      }
      this.sampleBtnDisable = false;
    }, err => {
      // Error Handling
      this.sampleBtnDisable = false;
    });
  }

  private saveToSampleReportFile(response) {
    const blob = new Blob([response], { type: 'text/pdf' });
    saveAs(blob, 'Valzy - Sample Internal Business Valuation Report.pdf');
  }

  /**
   * @description apply promocode
   */
  applyPromoCode() {
    if (this.promo.trim() && this.reportId) {
      this.reportProvider.applyPromo(this.reportId, this.promo.trim()).subscribe(res => {
        if (res.success) {
          this.payableAmount = res?.result?.TOTAL_PRICE;
          this.totalDiscount = res?.result?.DISCOUNT;
        }
      }, err => {
        // Error Handling
      });
    }
  }

  /** get renew discount */
  get calcRenewPrice(): number{
    if(this.totalDiscount) {
      return Math.round(this.renewPrice - ((this.renewPrice * this.totalDiscount) / 100));
    }else{
      return this.renewPrice;
    }
  }
}
